import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="RedShelf"
      src="https://static.redshelf.com/static/v3/img/logos/redshelf-logo.svg"
      {...props}
    />
  );
};

export default Logo;
